<style lang="less" scoped>
.title-div {
  font-weight: 600;
  margin: 20px 10px 10px;
  font-size: 26px;
  flex-grow: 1;
  color: #000;
}
</style>

<template>
  <div class="detail-content-div">
    <div class="title-div">预约信息</div>
    <!-- getReservation 返回 List<PileOrderAppDto>，非分页结构，按整表展示 -->
    <el-table class="el-table" :data="tableData" border style="width: 100%;margin:20px auto"
      :cell-style="{ 'text-align': 'center' }"
      :header-cell-style="{ background: '#FAFAFA', color: '#8F9BB3', fontSize: '14px', textAlign: 'center', border: '1px solid #F0F0F0' }">
      <el-table-column prop="custPhone" label="用户手机号"></el-table-column>
      <el-table-column prop="bindSource" label="来源"></el-table-column>
      <el-table-column prop="onOff" label="开关"></el-table-column>
      <el-table-column prop="remark" label="预约策略" min-width="240"></el-table-column>
      <el-table-column prop="updateDate" label="创建时间" :formatter="timeFormatter"></el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 预约策略列表（/pileOrder/getReservation 返回 List，非分页）
      tableData: [],
      pileCode: '',
    }
  },
  methods: {
    init() {
      // pileCode 由详情页 tab 容器经 store.pileObj 透传，与 user-list 等兄弟组件一致
      if (this.$store.state.pileObj) {
        this.pileCode = this.$store.state.pileObj.pileCode
        this.getList()
      }
    },
    // 查询当前桩开启中的预约/定时充电策略
    getList() {
      let _ = this
      _.$H.post(_, _.$A.pile.getReservation, { pileCode: _.pileCode }).then((res) => {
        _.tableData = res.data.data || []
      })
    },
    // 创建时间格式化：兼容后端返回的时间戳(数字)或字符串，避免 Date 被序列化成时间戳直接展示
    timeFormatter(row, column, cellValue) {
      return this.formatTime(cellValue)
    },
    formatTime(val) {
      if (!val) return ''
      let d
      if (typeof val === 'number') {
        d = new Date(val)
      } else {
        // 纯数字字符串(长度>=10 视为时间戳)按时间戳解析，否则按日期字符串解析
        const n = Number(val)
        d = (!isNaN(n) && String(val).length >= 10) ? new Date(n) : new Date(val)
      }
      if (isNaN(d.getTime())) return val
      function pad(x) { return x < 10 ? '0' + x : '' + x }
      return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) +
        ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes()) + ':' + pad(d.getSeconds())
    },
  },
  mounted() {
    this.init()
  },
}
</script>
